import { parseAsInteger, useQueryStates } from 'nuqs';
import type { LotSizingWeekRange } from '@/types/core/lot-sizing/lot-sizing-week-range';

export type PurchasePlanningWeekParams = LotSizingWeekRange & {
  page: number;
};

export function usePurchasePlanningWeekParams() {
  const [weekParams, setWeekParams] = useQueryStates(
    {
      year: parseAsInteger,
      week: parseAsInteger,
      endYear: parseAsInteger,
      endWeek: parseAsInteger,
      page: parseAsInteger,
    },
    {
      history: 'replace',
    },
  );

  return {
    weekParams: weekParams as PurchasePlanningWeekParams,
    setWeekParams,
  };
}
